module.exports = global["React"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react/index.js-exposed
// module id = 1
// module chunks = 2